import React from 'react';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip as ChartTooltip, XAxis, YAxis } from 'recharts';
import { SectionCard } from '../common/SectionCard';
import { recommendationImpact } from '../../data/analytics';
export function RecommendationImpact() {
  const triggered = recommendationImpact.reduce((sum, row) => sum + row.triggered, 0);
  const accepted = recommendationImpact.reduce((sum, row) => sum + row.accepted, 0);
  return <SectionCard title="Recommendation impact by stage" description="Preset rules triggered against recommendations accepted by officers" actions={<span className="rounded-sm border border-uae-leaf/30 bg-uae-leaf/10 px-1.5 py-0.5 font-mono text-[11px] text-uae-leaf" data-id="element-464" data-mp="3ri20vc5gfa36">
          {Math.round(accepted / triggered * 100)}% accepted
        </span>} data-id="element-463" data-mp="3vlgpgr7gkys8">
      <div className="h-60 w-full" data-id="element-465" data-mp="2g2ddijoag91u">
        <ResponsiveContainer width="100%" height="100%" data-id="element-466" data-mp="2b5dfmw1leclt">
          <BarChart data={recommendationImpact} margin={{
          top: 4,
          right: 8,
          left: -20,
          bottom: 0
        }} data-id="element-467" data-mp="2b7zocz07yy5m">
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} data-id="element-468" data-mp="1wvojf0p0zg8h" />
            <XAxis dataKey="stage" tick={{
            fontSize: 10,
            fill: 'var(--muted-foreground)'
          }} interval={0} tickLine={false} axisLine={{
            stroke: 'var(--border)'
          }} data-id="element-469" data-mp="1iw6os4p1t8r7" />
            <YAxis allowDecimals={false} tick={{
            fontSize: 11,
            fill: 'var(--muted-foreground)'
          }} tickLine={false} axisLine={false} data-id="element-470" data-mp="194ankkro12ir" />
            <ChartTooltip contentStyle={{
            fontSize: 12,
            borderRadius: 4,
            border: '1px solid var(--border)'
          }} data-id="element-471" data-mp="1070ft9e23vil" />
            <Legend wrapperStyle={{
            fontSize: 11
          }} data-id="element-472" data-mp="q79iz120x4fc" />
            <Bar dataKey="triggered" name="Triggered" fill="var(--chart-3)" radius={[2, 2, 0, 0]} data-id="element-473" data-mp="q7hw8u226br2" />
            <Bar dataKey="accepted" name="Accepted" fill="var(--chart-1)" radius={[2, 2, 0, 0]} data-id="element-474" data-mp="v5jh9kj1ol56" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </SectionCard>;
}